export const UPDATE_WEBPAGES = 'UPDATE_WEBPAGES'
export const UPDATE_WEBPAGE_PAGINATION = 'UPDATE_WEBPAGE_PAGINATION'
export const UPDATE_WEBPAGE_SEARCH_TERM = 'UPDATE_WEBPAGE_SEARCH_TERM'
